<mat-drawer-container hasBackdrop="true" (backdropClick)="backdropClick()">
  <mat-drawer-content>
    <app-loading></app-loading>
    <app-toaster></app-toaster>
    <router-outlet></router-outlet>
  </mat-drawer-content>
  <mat-drawer #drawer position="end" mode="over">
    <app-installments-dropdown-drawer></app-installments-dropdown-drawer>
  </mat-drawer>
</mat-drawer-container>
